import React from 'react'

import Base from '../../_Base'

const Ok16 = (props) => (
  <Base
    aria-hidden="true"
    focusable="false"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        d="M10.004 11.627a7.729 7.729 0 0 0 2.398-.994 1.21 1.21 0 0 0-1.29-2.05 5.244 5.244 0 0 1-5.56 0 1.211 1.211 0 0 0-1.29 2.05 7.729 7.729 0 0 0 2.398.994l-2.306 2.308a1.208 1.208 0 1 0 1.71 1.71l2.27-2.268 2.268 2.269a1.208 1.208 0 1 0 1.71-1.71l-2.308-2.309m-1.67-9.206c.943 0 1.71.767 1.71 1.71a1.711 1.711 0 0 1-3.421 0c0-.944.769-1.71 1.71-1.71zm0 5.837a4.133 4.133 0 0 0 4.129-4.127A4.134 4.134 0 0 0 8.332 0a4.134 4.134 0 0 0-4.129 4.13 4.134 4.134 0 0 0 4.13 4.128z"
        fill="black"
        className="logo"
      />
    </g>
  </Base>
)

export default Ok16
